import axios from 'axios'

const axiosInstance = axios.create({
    baseURL: '/api',
    headers: {
      'DMSAuth': process.env.VUE_APP_DMS_AUTH
    },
    withCredentials: true
})

export abstract class BucketAPIHelper {
    static startUpload (fileSize: number) {
        return axiosInstance.post(
            '/dermoscopies', {
                fileSize
            }
        )
    }

    static completeUpload (key: string, parts: any[], uploadId: string) {
        return axiosInstance.patch(
            '/dermoscopies', {
                key,
                parts,
                uploadId
            }
        )
    }

    static getPatients () {
        return axiosInstance.get(
            '/patients'
        )
    }

    static getPatientMediasURLs (patientId: string) {
        return axiosInstance.get(
            '/patients?id=' + patientId
        )
    }

    static login (password: string) {
        return axiosInstance.post(
            '/login', {}, {
                headers: {
                    'authorization-token': `Bearer ${password}`
                }
            }
        )
    }
}